// extracted by mini-css-extract-plugin
export var chip = "_gr-0";
export var filterDropdown = "_gr-5";
export var filterItem = "_gr-6";
export var icon = "_gr-1";
export var removeButton = "_gr-3";
export var removeIcon = "_gr-4";
export var separator = "_gr-2";